import { render, staticRenderFns } from "./newLoudMainDetails.vue?vue&type=template&id=b5b22566&scoped=true"
import script from "./newLoudMainDetails.vue?vue&type=script&lang=js"
export * from "./newLoudMainDetails.vue?vue&type=script&lang=js"
import style0 from "./newLoudMainDetails.vue?vue&type=style&index=0&id=b5b22566&prod&scoped=true&lang=scss"
import style1 from "./newLoudMainDetails.vue?vue&type=style&index=1&id=b5b22566&prod&lang=css"
import style2 from "./newLoudMainDetails.vue?vue&type=style&index=2&id=b5b22566&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b22566",
  null
  
)

export default component.exports